<template>
	<transition name="fade">
		<keep-alive include="ListView">
      <router-view id="app"/>
    </keep-alive>
	</transition>
</template>

<script>

export default {
  components: {
  },
  metaInfo() {
    return (this.$route && this.$route.meta && this.$route.meta.seo)?this.$route.meta.seo:{};
  },
  methods: {
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>
